import React, { Component } from "react";
import styles from "./deleteButton.module.scss";
import TooltipWrapper from "../../shared/items/contols/tooltipWrapper";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";

class DeleteButton extends Component {
  onDeleteIconClick(e) {
    e.stopPropagation();
    const { handleClick = (e) => {} } = this.props;
    handleClick(e);
  }

  render() {
    const { tooltipText = "Удалить", toolTipPosition = "left", text = "Удалить", iconSize = "small" } = this.props;

    return (
      <div onClick={this.onDeleteIconClick.bind(this)}>
        <TooltipWrapper title={tooltipText} position={toolTipPosition}>
          <div className={styles.deleteButtonContainer}>
            <DeleteOutlineIcon fontSize={iconSize} />
            <span>{text}</span>
          </div>
        </TooltipWrapper>
      </div>
    );
  }
}

export default React.memo(DeleteButton);
